import { SVGProps } from 'react'

export const Filter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" fill="currentColor" fillOpacity="0.08" rx="18"></rect>
    <path
      fill="currentColor"
      d="M17.167 23h1.666a.836.836 0 00.834-.833.836.836 0 00-.834-.834h-1.666a.836.836 0 00-.834.834c0 .458.375.833.834.833zM10.5 13.833c0 .459.375.834.833.834h13.334a.836.836 0 00.833-.834.836.836 0 00-.833-.833H11.333a.836.836 0 00-.833.833zm3.333 5h8.334A.836.836 0 0023 18a.836.836 0 00-.833-.833h-8.334A.836.836 0 0013 18c0 .458.375.833.833.833z"
    ></path>
  </svg>
)
